import React, { FC } from 'react';
import { SelectPicker } from 'rsuite';
import clsx from 'clsx';
import { FilterComponent } from '../../FilterComponent';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../../store/merchnts/merchants-context';

interface Props {
  paymentActiveStatus: string | null;
  setPaymentActiveStatus: (status: string | null) => void;
}

export const PaymentGatewayFilters: FC<Props> = ({ paymentActiveStatus, setPaymentActiveStatus }) => {
  const { t } = useTranslation();
  const { merchantState: { merchantsLists }} = useMerchants();

  return (
    <div className="d-flex align-items-center fc-filter-line">
      <FilterComponent value={paymentActiveStatus} isGrey>
        <SelectPicker
          data={merchantsLists?.merchantStatuses}
          appearance="subtle"
          placement="bottomEnd"
          placeholder={t('MERCHANTS_LIST.SELECT_STATUS')}
          onSelect={(status): void => setPaymentActiveStatus(status)}
          className={clsx('fc-selector grey-bgc timezone-selector', paymentActiveStatus ? 'fc-selector-cleanable' : 'fc-added-icon')}
          onClean={(): void => setPaymentActiveStatus(null)}
          searchable={false}
          value={paymentActiveStatus}
          defaultValue={paymentActiveStatus}
        />
      </FilterComponent>
    </div>
  );
};